import { dehydrate, QueryClient } from '@tanstack/react-query';
import { getGetPricingQueryOptions } from '@/api/gen/pricing/pricing.gen';
import { Pricing } from '@/module/payment/Pricing/Pricing';
import { CountryCodeFromServerProvider } from '@/shared/contexts';
import { UserCookieManager } from '@/shared/cookies';
import { serverLogger } from '@/shared/logger/serverLogger';
import { withSsrLogging } from '@/shared/logger/withSsrLogging';
import { getDefaultServerSideProps } from '@/utils/next';
import { withServerSideUserCountryCode } from '@/utils/next/withServerSideUserCountryCode';
const QUIZ_SESSION_COOKIE_NAME = 'session-quiz-zep';
export default function PricingPage(props: {
  userCountryCode?: string;
  hasSessionHint: boolean;
}) {
  const userCountryCode = props.userCountryCode?.trim().toUpperCase() || 'US';
  return <CountryCodeFromServerProvider countryCode={userCountryCode} data-sentry-element="CountryCodeFromServerProvider" data-sentry-component="PricingPage" data-sentry-source-file="index.page.tsx">
      <Pricing hasSessionHint={props.hasSessionHint} data-sentry-element="Pricing" data-sentry-source-file="index.page.tsx" />
    </CountryCodeFromServerProvider>;
}
export const getServerSideProps = withSsrLogging('pricing', withServerSideUserCountryCode(async ctx => {
  const queryClient = new QueryClient();
  const userCountryCode = UserCookieManager.getPreferredCountryCode(ctx.req)?.trim().toUpperCase() ?? 'US';
  const defaultServerSideProps = await getDefaultServerSideProps({
    ...ctx,
    namespaces: ['common', 'pricing']
  });
  try {
    await queryClient.prefetchQuery(getGetPricingQueryOptions({
      countryCode: userCountryCode
    }));
  } catch (e) {
    serverLogger.error({
      err: e
    }, 'pricing prefetch error');
  }
  return {
    props: {
      ...defaultServerSideProps.props,
      dehydratedState: dehydrate(queryClient),
      userCountryCode,
      hasSessionHint: ctx.req.cookies[QUIZ_SESSION_COOKIE_NAME] === 'true' || Boolean(UserCookieManager.getUserCountryCode(ctx.req))
    }
  };
}));